import React, { Component } from 'react'
import { inject, observer, PropTypes as MobxPropTypes } from 'mobx-react'
import { Col, Row } from 'react-bootstrap'
import moment from 'moment'
import { Heading, ContainerBox } from './AdminStyle';

import cssVar from '../../styles/variables'
import styled from 'styled-components'

import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';

@inject('residenceBookingStore', 'userStore', 'adminStore', 'partnersStore')

@observer
class Admin extends Component {

  componentWillMount() {
    this.props.adminStore.getApplications()
  }

  sortDates(a, b, order) {
    let indices = [6, 7, 8, 9, 3, 4, 0, 1];
    if (order === 'asc') {
      let r = 0;
      indices.find(i => r = a.date.charCodeAt(i) - b.date.charCodeAt(i));
      return r;
    } else if (order === 'desc') {
      let r = 0;
      indices.find(i => r = b.date.toString().charCodeAt(i) - a.date.toString().charCodeAt(i));
      return r;
    }
  }

  addTagFormating = (cell, row) => {
    return (
      <div>
        { cell.map( item => item.enabled ? <Tag color={item.color}>{ item.title }</Tag> : <span></span> )}
      </div>
    );
  }

  onRowClick = row => {
    this.props.history.push(`/internal/admin/applications/${row.objectId}`);
  }

  render() {
    const { isAdmin, isLoge } = this.props.userStore;
    const { isApplications, applications } = this.props.adminStore;
    // let bookings = []
    let applicationItems = []
    // let userItems = []
    // let partnersItems = []

    const options = {
      onRowClick: this.onRowClick,
      defaultSortName: 'date',
      defaultSortOrder: 'desc'
    };

    if (isApplications) {
      applications
      .filter(item => !!item.waitlist)
      .map((app, idx) => {
        const leadstatus = app.leadstatus
        applicationItems.push({
          objectId: app.objectId,
          date: moment(app.createdAt).locale("en").format('DD/MM/YYYY'),
          // golfcourse: app.golfcourse,
          // knownMember: app.knownMember,
          name: (app.title || "") + " " + (app.firstname || "") + " " + (app.lastname || ""),
          // position: app.position,
          company: app.company,
          region: app.region && `${app.region.title}, ${app.region.country.title}`,
          phone: app.phone,
          email: app.email,
          leadtags: !leadstatus ? [] : [
            { title: "Bewerbung", color: cssVar.colors.gold, enabled: leadstatus.includes("applicant") },
            { title: "Mitglied", color: cssVar.colors.gold, enabled: leadstatus.includes("member") },
          ],
        })
      })
    }


    if (!isAdmin) {
      //this.props.history.push("/")
    }


    return (
      <div>
        {(isAdmin || isLoge) ?
          <div>

            <Row style={{maxWidth: 1200, margin: "0 auto"}}>
              <Col xs={12} md={12} lg={12} className={'mobile-no-padding'} >
                <ContainerBox>
                  <Heading>BEWERBUNGS WARTELISTE</Heading>
                  <div style={{ marginLeft: 15, borderBottom: "1px solid rgb(33,45,61,15%)", width: "25%", marginBottom: 10 }}></div>

                  <div style={{ color: 'black', margin: 15 }} className={'bootstrap-table applications'}>
                    {!isApplications
                      ? "Keine Bewerbungen"
                      : <BootstrapTable data={applicationItems} borderless={true} options={options} hover={true} search pagination bodyStyle={{cursor: "pointer"}}>
                        <TableHeaderColumn dataField="objectId" isKey hidden={true}>ID</TableHeaderColumn>
                        <TableHeaderColumn dataField="date" dataSort={true} sortFunc={this.sortDates}>beworben am</TableHeaderColumn>
                        {/* <TableHeaderColumn dataField="golfcourse">Golfclub</TableHeaderColumn> */}
                        {/* <TableHeaderColumn dataField="knownMember" dataSort={true}>Bekanntes Mitglied</TableHeaderColumn> */}
                        <TableHeaderColumn dataField="name" dataSort={true}>Name</TableHeaderColumn>
                        <TableHeaderColumn dataField="company">Firma</TableHeaderColumn>
                        <TableHeaderColumn dataField="region">Region</TableHeaderColumn>
                        {/* <TableHeaderColumn dataField="position">Position</TableHeaderColumn> */}
                        <TableHeaderColumn dataField="phone">Telefonnummer</TableHeaderColumn>
                        <TableHeaderColumn dataField="email">E-Mail</TableHeaderColumn>
                        <TableHeaderColumn dataField="leadtags" dataFormat={this.addTagFormating}>Lead Status</TableHeaderColumn>
                      </BootstrapTable>
                    }
                  </div>

                </ContainerBox>
              </Col>
            </Row>
          </div>
          : ''}

      </div>
    )
  }
}

Admin.propTypes = {
  golfCourseStore: MobxPropTypes.observableObject
}

export default Admin

const Tag = styled.div`
  display: inline-block;
  width: auto;
  background: ${ props => props.color };
  color: white;
  font-size: 14px;
  line-height: 26px;
  height: 26px;
  border-radius: 13px;
  padding: 0 8px;

  &:not(:last-child) {
    margin-right: 5px;
  }
`


// WEBPACK FOOTER //
// /src/components/admin/ApplicationWaitlist.js